import api from '../api';

const AzureMapsService = {
	getAddressSuggestions: (query, config = {}) => {
		return api.get(`/addressAutocomplete`, {
			params: { query },
			...config
		});
	}
};

export default AzureMapsService;
